import { useEffect } from 'react';

import { FirebaseService, httpService } from '@flexo/general';
import { useDispatch, useSelector } from 'react-redux';
import { METADATA, USER, ALERT } from '@flexo/reducers';


const ENV = (import.meta as any).env;


const firebaseService = new FirebaseService();

export const CommunitiesOverviewResolver = () => {

  const dispatch = useDispatch();

  async function init() {
    const idToken = await firebaseService.getIdToken();

    if (!idToken) {
      dispatch(ALERT.SetAlert({
        value: {
          type: 'BANNER_SESSION_EXPIRED'
        },
      } as any));

      dispatch(USER.SetLogout());

      return;
    }


    const [overview] = await Promise.all([
      httpService
        .get({
          url: `${ENV.VITE_APP_BASE_URL}/hive/api/catalog/v1_3/organization/${ENV.VITE_APP_ORG_ID}/overview`,
          idToken,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {

            dispatch(ALERT.SetAlert({
              value: {
                type: 'BANNER_UNEXPECTED_ERROR'
              },
            } as any));

            return null;
          }
        })
        .catch((err: any) => {

          dispatch(ALERT.SetAlert({
            value: {
              type: 'BANNER_UNEXPECTED_ERROR'
            },
          } as any));

          return null;
        }),
    ]);

    dispatch(METADATA.SetCommunitiesOverview(overview));

  }

  useEffect(() => {
      init();
  }, []);

  return <></>;
};
